export default __webpack_public_path__ + "static/AGaramondPro-Bold-4d7de31ac9d459e739ae15594bc31db7.ttf";